export default class ModalSecteurController {
	static $inject = ['$scope', '$stateParams', 'notification', '$translate'];

	constructor($scope, $stateParams, notification, $translate) {
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.notification = notification;
		this.$translate = $translate;
		this.secteur = {};
	}

	async $onInit() {
		const secteurs = this.resolve.selectedRapportRow.secteurs;
		const maxOrder = secteurs.length > 0 ? Math.max(...secteurs.map((x) => x.order)) : 0;

		const defaultSecteur = {
			label: '',
			order: maxOrder + 1,
			production: 5,
			achatInterne: 1,
			achatExterne: 1,
			ventesBl: 1,
			cessionsInternes: 1,
			negocesDirecte: 1,
			transfert: 5,
			ajustement: 5,
			recomposition: 1,
			ecartsInventaire: 1,
			variation: 1,
			produits: []
		};

		this.secteur = this.resolve.secteurOrder ? secteurs.find((x) => x.order === this.resolve.secteurOrder) : defaultSecteur;

		this.secteursMapping = [
			{ key: 'production', label: 'Production', withSaisie: true },
			{ key: 'achatInterne', label: 'Achat interne', withSaisie: false },
			{ key: 'achatExterne', label: 'Achat externe', withSaisie: false },
			{ key: 'ventesBl', label: 'Ventes (BL)', withSaisie: false },
			{ key: 'cessionsInternes', label: 'Cessions internes', withSaisie: false },
			{ key: 'negocesDirecte', label: 'Négoces directe', withSaisie: false },
			{ key: 'transfert', label: 'Transfert', withSaisie: true },
			{ key: 'ajustement', label: 'Ajustement', withSaisie: true },
			{ key: 'recomposition', label: 'Recomposition', withSaisie: false },
			{ key: 'ecartsInventaire', label: 'Ecarts inventaire', withSaisie: false },
			{ key: 'variation', label: 'Variation', withSaisie: false }
		];
	}

	isFlagSet(value, flag) {
		return (value & flag) === flag;
	}

	isFormValid({ label }) {
		return Boolean(label);
	}

	handleChange = (event, key, value, flag) => {
		const isChecked = event.target.checked;

		// Update the value based on the checkbox state
		if (isChecked) {
			value |= flag; // Set the flag
		} else {
			value &= ~flag; // Unset the flag
		}

		// Update the secteur object with the modified value
		this.secteur[key] = value;

		this.resolve.selectedRapportRow.isChanged = true;
	};

	ok() {
		this.close({
			$value: this.secteur
		});
	}

	cancel() {
		this.dismiss();
	}
}
